import { render, staticRenderFns } from "./EventPersonList.vue?vue&type=template&id=2a7422b5&scoped=true&"
import script from "./EventPersonList.vue?vue&type=script&lang=js&"
export * from "./EventPersonList.vue?vue&type=script&lang=js&"
import style0 from "./EventPersonList.vue?vue&type=style&index=0&id=2a7422b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7422b5",
  null
  
)

export default component.exports